import { render, staticRenderFns } from "./notice-view.vue?vue&type=template&id=13ed12b4&scoped=true&"
import script from "./notice-view.vue?vue&type=script&lang=js&"
export * from "./notice-view.vue?vue&type=script&lang=js&"
import style0 from "./notice-view.vue?vue&type=style&index=0&id=13ed12b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ed12b4",
  null
  
)

export default component.exports